if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super()
      this.input = this.querySelector('input[type="search"]')
      this.inputClear = this.querySelector('[data-search-form-input-clear]')
      this.predictiveSearchQuicklinks = this.querySelector('.predictive-search__quicklinks')
      this.predictiveSearchResults = this.querySelector('.predictive-search__results-inner')

      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event)
        }, 100).bind(this),
      )
      this.input.addEventListener('focus', this.handleInputFocus.bind(this))
      this.input.addEventListener('blur', this.handleInputBlur.bind(this))
      this.inputClear.addEventListener('click', this.handleClearIconClick.bind(this))
      document.addEventListener('activate-filters', this.focusInput.bind(this))
    }

    onChange() {
      const searchTerm = this.input.value.trim()
      if (!searchTerm.length) {
        this.close()
        this.toggleClearIcon(false)
        return
      }
      this.toggleClearIcon(true)
      this.open()
      this.getSearchResults(searchTerm)
    }

    getSearchResults(searchTerm) {
      fetch(`${routes.predictive_search_url}?q=${searchTerm}&resources[type]=collection,product,page,article&resources[limit]=10&section_id=predictive-search`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status)
            this.close()
            throw error
          }

          return response.text()
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML
          if (this.input.value.trim()) {
            this.predictiveSearchQuicklinks.classList.add('predictive-search__quicklinks--hidden')
            this.predictiveSearchResults.innerHTML = resultsMarkup
            this.classList.add('predictive-search--active')
          } else {
            this.predictiveSearchQuicklinks.classList.remove('predictive-search__quicklinks--hidden')
            this.predictiveSearchResults.innerHTML = ''
            this.classList.remove('predictive-search--active')
          }
        })
        .catch((error) => {
          this.close()
          throw error
        })
    }

    open() {
      this.predictiveSearchResults.style.display = 'block'
    }

    close() {
      this.classList.remove('predictive-search--active')
      this.predictiveSearchResults.style.display = 'none'
      this.predictiveSearchResults.innerHTML = ''
    }

    focusInput() {
      this.input.focus()
      this.input.selectionStart = this.input.selectionEnd = 10000
    }

    handleInputFocus() {
      if (!this.input.value.trim()) {
        this.predictiveSearchQuicklinks.classList.remove('predictive-search__quicklinks--hidden')
      } else {
        const searchTerm = this.input.value.trim()
        this.predictiveSearchQuicklinks.classList.add('predictive-search__quicklinks--hidden')
        this.getSearchResults(searchTerm)
      }
    }

    handleInputBlur() {
      setTimeout(() => {
        this.predictiveSearchQuicklinks.classList.add('predictive-search__quicklinks--hidden')
      }, 100)
    }

    toggleClearIcon(show) {
      if (show) {
        this.inputClear.classList.add('search-form__input-clear--active')
      } else {
        this.inputClear.classList.remove('search-form__input-clear--active')
      }
    }

    handleClearIconClick() {
      const inputEvent = new Event('input')

      this.input.value = ''
      this.input.dispatchEvent(inputEvent)
    }
  }

  window.PredictiveSearch = PredictiveSearch

  customElements.define('predictive-search', PredictiveSearch)
}
